// extracted by mini-css-extract-plugin
export default {"tarjeta":"Tarjeta_tarjeta__D+JqH","icon":"Tarjeta_icon__r3xnk"};